import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const options = [
  { label: 'LVM (not for production use)', value: 'LVM' },
  { label: 'NFS (not for production use)', value: 'NFS' },
  { label: 'NetApp Data ONTAP NFS', value: 'NetAppONTAPNFS' },
  { label: 'NetApp Data ONTAP FC', value: 'NetAppONTAPFC' },
  { label: 'NetApp Data ONTAP ISCSI', value: 'NetAppONTAPISCSI' },
  { label: 'NetApp Data ONTAP NVMe', value: 'NetAppONTAPNVMe' },
  { label: 'Pure Storage ISCSI', value: 'PureStorageISCSI' },
  { label: 'Pure Storage FC', value: 'PureStorageFC' },
  { label: 'Pure Storage NVME', value: 'PureStorageNVME' },
  { label: 'Hitachi ISCSI', value: 'HitachiISCSI' },
  { label: 'Hitachi FC', value: 'HitachiFC' },
  { label: 'Infinidat ISCSI', value: 'InfinidatISCSI' },
  { label: 'Huawei Dorado ISCSI', value: 'HuaweiISCSI' },
  { label: 'Huawei Dorado FC', value: 'HuaweiFC' },
  { label: 'HPE 3PAR ISCSI', value: 'HPE3PARISCSI' },
  { label: 'HPE 3PAR FC', value: 'HPE3PARFC' },
  { label: 'Tintri NFS', value: 'Tintri' },
  { label: 'Custom', value: 'Custom' },
]

interface Props {}

export default function BackendDriverPicklist({
  name = 'driver',
  label = 'Storage Driver',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
